export default __webpack_public_path__ + "static/media/interestedInLearning_bg.8e288d41.svg";